module.exports = __webpack_public_path__ + "static/media/what-is-dito.bc210e3c.png";